import { StyleSheet } from 'react-native';

const s = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  dialog: {
    backgroundColor: '#1e2d3d',
    borderRadius: 10,
    maxHeight: '85%',
    borderWidth: 1,
    borderColor: '#3d5a73',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 14,
    borderBottomWidth: 1,
    borderBottomColor: '#3d5a73',
  },
  headerTitle: {
    fontFamily: 'Poppins_600SemiBold',
    fontSize: 16,
    color: '#ffffff',
  },
  closeIcon: {
    padding: 4,
  },
  body: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    flex: 1,
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderTopWidth: 1,
    borderTopColor: '#3d5a73',
    gap: 10,
  },

  // Loading
  loadingContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 40,
  },
  loadingText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 14,
    color: '#E0E7EF',
    marginTop: 12,
  },

  // Error
  errorContainer: {
    alignItems: 'center',
    paddingVertical: 24,
  },
  errorText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 14,
    color: '#e74c3c',
    textAlign: 'center',
    marginTop: 10,
    marginBottom: 16,
    paddingHorizontal: 12,
  },
  errorButtons: {
    flexDirection: 'row',
    gap: 10,
  },
  lockedList: {
    backgroundColor: '#253c57',
    borderRadius: 6,
    padding: 10,
    marginBottom: 12,
    width: '100%',
  },
  lockedLabel: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 12,
    color: '#E0E7EF',
    marginBottom: 4,
  },
  lockedIds: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 12,
    color: '#f39c12',
  },
  retryButton: {
    backgroundColor: '#336599',
    borderRadius: 6,
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
  retryButtonText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 14,
    color: '#ffffff',
  },
  closeButton: {
    borderRadius: 6,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderWidth: 1,
    borderColor: '#5c778f',
  },
  closeButtonText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 14,
    color: '#E0E7EF',
  },

  // Preview
  previewContainer: {
    flex: 1,
  },
  summaryBar: {
    backgroundColor: '#253c57',
    borderRadius: 6,
    padding: 10,
    marginBottom: 12,
  },
  summaryText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 13,
    color: '#E0E7EF',
  },
  scrollArea: {
    maxHeight: 400,
  },

  // Order cards
  orderCard: {
    backgroundColor: '#2a3f54',
    borderRadius: 8,
    padding: 12,
    marginBottom: 8,
    borderLeftWidth: 3,
    borderLeftColor: '#1CBB77',
  },
  orderNumber: {
    fontFamily: 'Poppins_600SemiBold',
    fontSize: 14,
    color: '#ffffff',
    marginBottom: 6,
  },
  changeRow: {
    marginTop: 4,
  },
  changeLabel: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 12,
    color: '#E0E7EF',
    marginBottom: 3,
  },
  chipContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 4,
  },
  greenChip: {
    backgroundColor: '#1CBB77',
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 2,
  },
  redChip: {
    backgroundColor: '#e74c3c',
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 2,
  },
  chipText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 11,
    color: '#ffffff',
  },
  itemText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 12,
    color: '#ffffff',
    marginLeft: 4,
  },
  ruleText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 12,
    color: '#E0E7EF',
    fontStyle: 'italic',
    marginLeft: 4,
  },

  // Unchanged orders
  unchangedHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#253c57',
    borderRadius: 6,
    padding: 10,
    marginTop: 8,
  },
  unchangedText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 13,
    color: '#E0E7EF',
  },
  unchangedCard: {
    backgroundColor: '#2a3f54',
    borderRadius: 6,
    padding: 8,
    marginTop: 4,
    opacity: 0.7,
  },
  unchangedOrderText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 12,
    color: '#E0E7EF',
  },

  // Apply result
  resultContainer: {
    flex: 1,
  },
  resultRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 6,
    gap: 8,
  },
  resultText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 13,
    color: '#ffffff',
  },
  resultErrorText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 12,
    color: '#f39c12',
    marginLeft: 4,
  },
  rerunFailedButton: {
    backgroundColor: '#336599',
    borderRadius: 6,
    paddingVertical: 10,
    paddingHorizontal: 16,
    alignSelf: 'center',
    marginTop: 12,
  },
  rerunFailedText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 14,
    color: '#ffffff',
  },

  // Footer buttons
  cancelButton: {
    borderRadius: 6,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderWidth: 1,
    borderColor: '#5c778f',
  },
  cancelButtonText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 14,
    color: '#E0E7EF',
  },
  applyButton: {
    backgroundColor: '#1CBB77',
    borderRadius: 6,
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
  applyButtonText: {
    fontFamily: 'Poppins_600SemiBold',
    fontSize: 14,
    color: '#ffffff',
  },
});

export default s;
